import React from "react";

export default function PageLoader() {
  return (
    <div className="d-flex flex-row justify-content-center my-5">
      <div className="spinner-border spinner-border-md color-mid-purple"></div>
    </div>
  );
}
